import axios from "@axios";
import * as ep from "./endpoints";
export default class Service {
  static fetchNotifications(page) {
    console.log("page" , page)
    return axios.get(ep.NOTIFICATIONS , {
      params: {
        page: page,
      }}).then((res) => res.data);
  }
  static addNotification(payload) {
    return axios.post(ep.NOTIFICATIONS, payload).then((res) => res.data);
  }
  static updateNotification(payload) {
    return axios
      .put(ep.NOTIFICATION_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }
  static deleteNotification(id) {
    return axios.delete(ep.NOTIFICATION_BY_ID(id)).then((res) => res.data);
  }
  static sendNotification(payload) {
    return axios.post(ep.SEND_NOTIFICATION, payload).then((res) => res);
  }
  static fetchReportRecord(params) {
    return axios.get(ep.REPORT_VIEW(params)).then((res) => res.data);
  }
  static fetchNgosSearchResults(key) {
    return axios.get(ep.NGOS_SEARCH_ENGINE(key)).then((res) => res.data);
  }
  static addQuestion(payload) {
    return axios.post(ep.QUESTIONS, payload).then((res) => res.data);
  }
  static updateQuestion(payload) {
    return axios
      .put(ep.QUESTION_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }
  static deleteQuestion(id) {
    return axios.delete(ep.QUESTION_BY_ID(id)).then((res) => res.data);
  }
  static fetchQuestions() {
    return axios.get(ep.QUESTIONS).then((res) => res.data);
  }

  static addCategory(payload) {
    return axios.post(ep.FAQ_CATEGORIES, payload);
  }
  static updateCategory(payload) {
    return axios.put(ep.FAQ_CATEGORY_BY_ID(payload.id), payload);
  }
  static deleteCategory(id) {
    return axios.delete(ep.FAQ_CATEGORY_BY_ID(id));
  }
  static fetchCategories() {
    return axios.get(ep.FAQ_CATEGORIES).then((res) => res.data);
  }

  static fetchRequest(id) {
    return axios.get(ep.REQUEST_BY_ID(id)).then((res) => res.data);
  }

  static fetchTransactionById(id) {
    return axios.get(ep.TRANSACTION_BY_ID(id)).then((res) => res.data);
  }
  static changeCurrentStage(payload) {
    return axios.post(ep.CURRENT_STAGE, payload);
  }

  static fetchTransactionActionsById(id) {
    return axios.get(ep.TRANSACTION_ACTIONS_BY_ID(id)).then((res) => res.data);
  }

  static updateTransactionActionsById(payload) {
    const fd = new FormData();
    fd.append("_method", "PUT");
    fd.append("days_number", payload.days_number);
    fd.append("description", payload.description);
    return axios.post(ep.TRANSACTION_ACTIONS_BY_ID(payload.id), fd).then((res) => res.data);
  }

  static startChecking(payload) {
    const fd = new FormData();
    fd.append("_method", "PUT");
    Object.keys(payload.data).forEach(key => {  
      if(key === 'is_last_action')
        fd.append(key, payload.data[key] || 0);
      else if(key === 'action_number')
        fd.append(key, payload.data[key] || 0);
      else if(key !== 'files') 
        fd.append(key, payload.data[key] || null);
      
    }); 
    if(payload.data.hasOwnProperty('files') ){
      if(payload.data.files.length > 0 ){

        payload.data.files.forEach((obj, index) => {

          fd.append(`doc[${index}][title]`, `${obj.title}`);
          fd.append(`doc[${index}][file]`, obj.file);
        });
      }
    }
    return axios.post(ep.TRANSACTION_BY_ID(payload.id), fd).then((res) => res);
  }

  static reAssignmentTransaction(payload) {
    console.log("payload" , payload)
    const fd = new FormData();
    fd.append("_method", "PUT");
    fd.append("ministry_user_id", payload.ministry_user_id);
    return axios.post(ep.REASIGN_TRANSACTION_BY_ID(payload.transaction_id), fd).then((res) => res);
  }

  static validateInfo(payload) {
    return axios.post(ep.VALIDATE, payload).then((res) => res.data);
  }

  static acceptName({ id, accepted }) {
    return axios.post(ep.ACCEPT_NAME(id), { accepted }).then((res) => res.data);
  }

  static sendFeedback(payload) {
    return axios.post(ep.FEEDBACK, payload).then((res) => res.data);
  }
  static changeStatus(id) {
    return axios.get(ep.CHANGE_STATUS(id)).then((res) => res.data);
  }
  static fetchHolidays() {
    return axios.get(ep.HOLIDAYS).then((res) => res.data);
  }
  static fetchHoliday(name) {
    return axios.get(ep.HOLIDAYS_BY_NAME(name)).then((res) => res.data);
  }
  static updateHoliday(payload) {
    return axios
    .put(ep.HOLIDAYS_BY_ID(payload.id), payload)
    .then((res) => res.data);
    
  }
  static addHoliday(payload) {
    return axios.post(ep.HOLIDAYS, payload).then((res) => res.data);
  }
  static deleteHoliday(id) {
    return axios.delete(ep.HOLIDAYS_BY_ID(id)).then((res) => res.data);
  }
  static fetchInstructions(id) {
    return axios.get(ep.INSTRUCTION_BY_ID(id)).then((res) => res.data);
  }

  static fetchHints(slug) {
    return axios.get(ep.HINTS_BY_SLUG(slug)).then((res) => res.data);
  }
  static updateInstruction(payload) {
    var toSend = new FormData();
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key];
        toSend.append(key, element);
      }
    }
    toSend.append("_method", "PUT");
    return axios
      .post(ep.INSTRUCTION_BY_ID(payload.id), toSend)
      .then((res) => res.data);
  }
  static updateHints(payload) {
    return axios.put(ep.HINTS, payload).then((res) => res.data);
  }

  static addRegulation(payload) {
    var toSend = new FormData();
    for (const key in payload.form) {
      if (Object.hasOwnProperty.call(payload.form, key)) {
        const element = payload.form[key];
        toSend.append(key, element);
      }
    }
    return axios
      .post(ep.REGULATIONS, toSend, { params: { model: payload.model } })
      .then((res) => res);
  }
  static updateRegulation(payload) {
    var toSend = new FormData();
    for (const key in payload.form) {
      if (Object.hasOwnProperty.call(payload.form, key)) {
        const element = payload.form[key];
        toSend.append(key, element);
      }
    }
    toSend.append("_method", "put");
    return axios
      .post(ep.REGUALTION_BY_ID(payload.form.id), toSend, {
        params: { model: payload.model },
      })
      .then((res) => res);
  }
  static deleteRegulation(id) {
    return axios.delete(ep.REGUALTION_BY_ID(id)).then((res) => res);
  }
  static addEvent(payload) {
    return axios.post(ep.EVENTS, payload).then((res) => res.data);
  }
  static updateEvent(payload) {
    return axios
      .put(ep.EVENT_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }
  static deleteEvent(id) {
    return axios.delete(ep.EVENT_BY_ID(id)).then((res) => res.data);
  }
  static addIncentive(payload) {
    return axios.post(ep.INCENTIVES, payload);
  }
  static updateIncentive(payload) {
    const toSend = payload.form;
    toSend.append("_method", "PUT");
    return axios.post(ep.INCENTIVE_BY_ID(payload.id), toSend);
  }
  static deleteIncentive(id) {
    return axios.delete(ep.INCENTIVE_BY_ID(id));
  }
  static getIncentives() {
    return axios.get(ep.INCENTIVES).then((res) => res.data);
  }
  static getIncentive(id) {
    return axios.get(ep.INCENTIVE_BY_ID(id)).then((res) => res.data);
  }

  static approveCampaign(id, status) {
    return axios
      .get(ep.CONFIRM_CAMPAIGN(id), { params: { status } })
      .then((res) => res.data);
  }
  static featureCampaign(id, val) {
    return axios
      .get(ep.FEATURE_CAMPAIGN(id), { params: { set: val } })
      .then((res) => res.data);
  }
  static addSlide(payload) {
    return axios.post(ep.SLIDES, payload);
  }
  static updateSlide(payload) {
    return axios.post(ep.SLIDE_BY_ID(payload.id), payload.form);
  }
  static deleteSlide(id) {
    return axios.delete(ep.SLIDE_BY_ID(id));
  }
  static fetchSlides() {
    return axios.get(ep.SLIDES).then((res) => res.data);
  }
  static addNgo(payload) {
    return axios.post(ep.NGOS, payload).then((res) => res.data);
  }
  static updateNgo(payload) {
    return axios.put(ep.NGO_BY_ID(payload.id), payload).then((res) => res.data);
  }
  static deleteNgo(id) {
    return axios.delete(ep.NGO_BY_ID(id)).then((res) => res.data);
  }
  // mediation-requestes
  static freezeRequest(id) {
    return axios.post(ep.MEDIATION_REQUEST_BY_ID(id)).then((res) => res.data);
  }
  static fetchRequest(id) {
    return axios.get(ep.MEDIATION_REQUEST(id)).then((res) => res.data);
  }

  static addType(payload) {
    return axios
      .post(ep.TYPES, payload.form, { params: { model: payload.model } })
      .then((res) => res);
  }
  static updateType(payload) {
    return axios.put(ep.TYPE_BY_ID(payload.id), payload).then((res) => res);
  }

  static deleteType(id) {
    return axios.delete(ep.TYPE_BY_ID(id)).then((res) => res);
  }

  static validateNgo(id, status) {
    return axios
      .get(ep.NGO_VALIDATE(id), {
        params: {
          status,
        },
      })
      .then((res) => res);
  }
  static fetchTransactionTypeById(id) {
    return axios.get(ep.TRANSACTION_TYPE_BY_ID(id)).then((res) => res.data);
  }
  static updateTransactionType(payload) {
    return axios.put(ep.TRANSACTION_TYPE_BY_ID(payload.id), payload).then((res) => res);
  }
}
